<template>
  <b-modal
    id="deletePosID"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    :visible="showSingleDelete"
    @hidden="closeDeleteSinglePositionID()"
  >
    <div>
      <div class="d-flex align-items-center justify-content-between pt-3 px-4">
        <div class="b-modal-header">Delete Position ID</div>
        <div
          class="rotate-on-hover"
          :class="{
            'disable-icon': deletePosLoader,
            pointer: !deletePosLoader,
            'global-disabledField': deletePosLoader,
          }"
        >
          <img
            @click="!deletePosLoader && closeDeleteSinglePositionID()"
            v-b-tooltip.hover.top="'Close'"
            src="@/assets/img/accessconnew/blueCross.svg"
            alt
          />
        </div>
      </div>
      <hr />
      <div>
        <div class="d-flex align-items-center px-4">
          <div class="set-w-px">
            <img src="@/assets/new-kanban-icons/inform-icon.svg" alt="" />
          </div>
          <div class="ml-1">
            <div class="addTocandJob-head">
              Reassign {{ positionIDDeleteData.candidateCount }}
              {{
                positionIDDeleteData.candidateCount > 1
                  ? "candidates"
                  : "candidate"
              }}
              to the remaining position IDs.
            </div>
            <div class="addTocandJob-subhead">
              Choose 'Assign Automatically' for auto-assignment or assign
              manually.
            </div>
            <div class="mt-2 new-center-radio d-flex align-items-center">
              <b-form-radio v-model="assignData" class="wordbreak" value="auto">
                Assign Automatically
              </b-form-radio>
              <b-form-radio
                v-model="assignData"
                class="wordbreak ml-3"
                value="manual"
              >
                Assign Manually
              </b-form-radio>
            </div>
          </div>
        </div>
        <div class="mt-3 px-1">
          <div class="available-font px-4">
            Select Position ID(s) among which candidates will be distributed:
          </div>
          <div
            class="
              d-flex
              align-items-center
              flex-wrap
              available-overflow
              px-4
              mt-3
            "
            style="gap: 20px"
          >
            <!-- 'selected-id' -->
            <div
              @click="
                !deletePosLoader &&
                  assignData !== 'auto' &&
                  addToPositionIDArray(pos)
              "
              class="position-id"
              :class="{
                'global-disabledField': deletePosLoader,
                'disabled-id': assignData === 'auto',
                'unselected-id':
                  !positionIDArray.includes(pos) && assignData !== 'auto',
                'selected-id':
                  positionIDArray.includes(pos) && assignData !== 'auto',
              }"
              v-for="pos in positionIDDeleteData.positionIDs"
              :key="pos"
            >
              {{ pos }}
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div
        class="d-flex align-items-center w-100 bluebtn mb-3 justify-content-end"
      >
        <div class="d-flex align-items-center">
          <b-button
            class="acs-cancelBtn-modal mr-3"
            @click="!deletePosLoader && closeDeleteSinglePositionID()"
            :disabled="deletePosLoader"
            >Cancel</b-button
          >
          <div class="position-relative">
            <button
              class="acs-addBtn-modal pl-4 pr-4 mr-3"
              @click="!deletePosLoader && continueToDelete()"
              :disabled="
                deletePosLoader ||
                (assignData !== 'auto' && positionIDArray.length === 0)
              "
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import toast from "@/components/mixin/toast";
export default {
  name: "DeleteSinglePositionID",
  props: {
    showSingleDelete: Boolean,
    deletePosLoader: Boolean,
    positionIDDeleteData: Object,
  },
  data() {
    return {
      assignData: "auto",
      positionIDArray: [],
    };
  },
  mixins: [toast],
  methods: {
    closeDeleteSinglePositionID() {
      this.$emit("close-modal");
    },
    addToPositionIDArray(pos) {
      const index = this.positionIDArray.indexOf(pos);
      if (index === -1) {
        this.positionIDArray.push(pos);
      } else {
        this.positionIDArray.splice(index, 1);
      }
    },
    continueToDelete() {
      this.$emit("delete-pos-id", this.positionIDArray);
    },
  },
};
</script>

<style scoped>
.addTocandJob-head {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  color: #333333;
}

.addTocandJob-subhead {
  font-family: "Montserrat", sans-serif;
  font-style: italic;
  font-weight: 500;
  font-size: 11px;
  line-height: 20px;
  color: #70737b;
}

.available-font {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #3a3c40;
}

.position-id {
  padding: 8px 10px;
  border-radius: 8px;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 16px;
}

.disabled-id {
  background: #e9e9e9;
  color: #3a3c40;
  opacity: 0.5;
  cursor: not-allowed;
}

.unselected-id {
  background: #e9e9e9;
  color: #3a3c40;
  cursor: pointer;
}

.selected-id {
  background: #20639b;
  color: #ffffff;
  cursor: pointer;
}

.available-overflow {
  min-height: auto;
  max-height: 250px;
  overflow: auto;
}
</style>
